import { ASSETS } from ".";

export const TEAM = [
  {
    name: "Dr. Max Mustermann",
    title: "Facharzt für Psychiatrie",
    image: ASSETS.DOCTOR_PORTRAIT,
    link: "",
  },
  {
    name: "Dr. Anna Müller",
    title: "Psychotherapeutin",
    image: ASSETS.TEAM_MEMBER_PORTRAIT,
    link: ""
  },
  {
    name: "Dr. Alex Jon",
    title: "Secretary",
    image: ASSETS.TEAM_MEMBER_PORTRAIT,
    link: ""
  },
  {
    name: "Joe Biden",
    title: "Eisverkäufer",
    image: ASSETS.TEAM_MEMBER_PORTRAIT,
    link: ""
  },
  {
    name: "Hasan",
    title: "Hausmeister",
    image: ASSETS.TEAM_MEMBER_PORTRAIT,
    link: ""
  },
];